import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";
import NameField from "../name-field/NameField";

interface LastNameFieldProps {
    register: UseFormRegisterReturn;
    error?: string;
    disabled?: boolean;
    width?: string;
    id?: string;
    placeholder?: string;
    className?: string;
}

const LastNameField = (props: LastNameFieldProps) => {
    return <NameField {...props} type="last" placeholder={props.placeholder} />;
};

export default LastNameField;
